export default "__VITE_ASSET__c4576538__"